// extracted by mini-css-extract-plugin
export var paginationContainer = "_79-0";